module.exports = __webpack_public_path__ + "img/sad (1).a0f4da6a.png";